import {PeerNetworkNodeModel} from "./peer-network-node.model";
import {RoamingPolicyPairModel} from "./roaming-policy-pair.model";

export class RoamingAgreementPeeringsModel {

  allNetworkServers: Array<PeerNetworkNodeModel> = [];
  allRoamingAgreements: Array<RoamingPolicyPairModel> = [];

  constructor(allNetworkServers: Array<PeerNetworkNodeModel> = [], allRoamingAgreements: Array<RoamingPolicyPairModel> = []) {
    this.allNetworkServers = allNetworkServers;
    this.allRoamingAgreements = allRoamingAgreements;
  }

  getAgreementFromTo(nsAId: string, nsBId: string) {
    let agreement = this.allRoamingAgreements.find((agreement) => {
      return (agreement.nsAid == nsAId && agreement.nsBid == nsBId) || (agreement.nsAid == nsBId && agreement.nsBid == nsAId);
    })
    return agreement;
  }
}
